const configuration = () => import('./pages/Configuration.vue')
const newConfiguration = () => import('./pages/NewConfiguration.vue')

const results = () => import('./pages/Results.vue')

const twoWayRoutes = [
  {
    path: 'twoway/configuration',
    name: 'twoway-configuration',
    component: configuration,
    meta: { requiresAuth: true, menuType: 'twoWay' },
  },
  {
    path: 'twoway/configuration/new/',
    name: 'new-two-way-configuration',
    component: newConfiguration,
    meta: { requiresAuth: true, menuType: 'twoWay' },
  },
  {
    path: 'twoway/configuration/edit/:configurationId',
    name: 'edit-two-way-configuration',
    component: newConfiguration,
    meta: { requiresAuth: true, menuType: 'twoWay' },
  },
  {
    path: 'twoway/results',
    name: 'twoway-results',
    component: results,
    meta: { requiresAuth: true, menuType: 'twoWay' },
  },
]

export default twoWayRoutes;